var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialui(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 204,
    viewBox: "0 0 256 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 110.848V0L96 55.424V92.3733L32 55.424V129.323L0 110.848Z",
    fill: "#00B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55.424L192 0V110.848L128 147.797L96 129.323L160 92.3733V55.424L96 92.3733V55.424Z",
    fill: "#0081CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 129.322V166.272L160 203.221V166.272L96 129.322Z",
    fill: "#00B0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 203.221L256 147.797V73.8987L224 92.3733V129.323L160 166.272V203.221ZM224 55.424V18.4747L256 0V36.9493L224 55.424Z",
    fill: "#0081CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialui);
export default __webpack_public_path__ + "static/media/materialui.518da2c04cdbcf8b4ca3e2ac554c38e9.svg";
export { ForwardRef as ReactComponent };